import React from "react";
import { IInspectionResponseModel } from "../../../typings/models/InspectionResponseModel";
import { useNavigate } from "react-router-dom";
import moment from "moment";

interface GridRowProps {
  data: IInspectionResponseModel;
}

const ISRInspectionGridRow: React.FC<GridRowProps> = ({ data }) => {
  let navigate = useNavigate();

  const handleAmendClick = (id: string) => {
    let path = `/isr-inspections`;
    navigate(path, { state: { id: id, mode: "amend" } });
  };

  return (
    <tr>
      <td>{data.inspectionCaseNumber}</td>
      <td>{data.salutation}</td>
      <td>{data.name}</td>
      <td>{data.uen}</td>
      <td>{data.companyName}</td>
      <td>{data.organisationalAddress}</td>
      <td>{data.mobileNo}</td>
      <td>{data.email}</td>
      <td>{data.inspectionLocation}</td>
      <td>{data.isrInspectionDateTime}</td>
      <td>{data.insAppModeofContact}</td>
      <td>
        <a href="#" onClick={() => handleAmendClick(data.inspectionCaseId)}>
          Amend
        </a>
      </td>
      {/* Add other data fields here */}
    </tr>
  );
};

export default ISRInspectionGridRow;
